export function formatCurrency(value, options = {}) {
    const { minimumFractionDigits = 2, maximumFractionDigits = 2, showSign = false, } = options;
    const isNegative = value < 0;
    const absoluteValue = Math.abs(value);
    const formatted = absoluteValue.toLocaleString('en-US', {
        minimumFractionDigits,
        maximumFractionDigits,
    });
    if (isNegative) {
        return `-$${formatted}`;
    }
    else if (showSign) {
        return `+$${formatted}`;
    }
    else {
        return `$${formatted}`;
    }
}
